<template>
  <SettingsPageFull>
    <template #title>
      <div class="flex space-x-3">
        <font-awesome-icon :icon="['fal', 'hotel']" size="2x" class="mr-3" />
        &nbsp;
        <span class="text-2xl font-bold capitalize-first">
          {{
            this.$route.name === 'settings_create_implantation_route'
              ? $t('button.add_new_f', { var: $t('global.implantation') })
              : pageTitle
          }}
        </span>
      </div>
    </template>

    <template #cta>
      <div class="flex gap-x-3">
        <div v-if="$can('manage_content')">
          <BaseButton
            v-if="editionMode"
            :isElevated="true"
            icon="paper-plane"
            @click="submitForm"
            :title="$t(buttonText, { var: $t('global.implantation') })"
          />
        </div>
        <BaseButton
          v-if="
            this.$route.name === 'settings_edit_implantation_route' &&
            $can('manage_content')
          "
          color="warning"
          :icon="editionMode ? 'times' : 'pen'"
          @click="getCompanyAndChangeEditionMode"
          :title="editionMode ? $t('button.cancel') : $t('button.edit')"
        />
        <BaseButton
          color="dark"
          icon="long-arrow-left"
          @click="this.$router.push({ name: 'settings_list_implantation' })"
          :title="$t('button.back')"
        />
      </div>
    </template>

    <template #body>
      <div class="flex flex-col gap-4">
        <PageSection
          disable-sticky-margin
          :title="$t('global.general_information')"
        >
          <div class="grid-form">
            <div>
              <BaseShowEditInput
                :label="$t('attributes.name')"
                v-model="implantation.name"
                :errors="errors.name"
                :placeholder="$t('attributes.name')"
                :editionMode="editionMode"
                :required="true"
              />
            </div>
            <div>
              <BaseShowEditInput
                :label="$t('attributes.street')"
                v-model="implantation.street"
                :errors="errors.street"
                :placeholder="$t('attributes.street')"
                :editionMode="editionMode"
              />
            </div>
            <div>
              <BaseShowEditInput
                :label="$t('attributes.reference')"
                v-model="implantation.reference"
                :errors="errors.reference"
                :placeholder="$t('attributes.reference')"
                :editionMode="editionMode"
              />
            </div>
            <div>
              <div class="mt-3 flex flex-row space-x-3">
                <BaseShowEditInput
                  :label="$t('attributes.post_code')"
                  v-model="implantation.post_code"
                  :errors="errors.post_code"
                  :placeholder="$t('attributes.post_code')"
                  :editionMode="editionMode"
                />
                <BaseShowEditInput
                  :label="$t('attributes.city')"
                  v-model="implantation.city"
                  :errors="errors.city"
                  :placeholder="$t('attributes.city')"
                  :editionMode="editionMode"
                />
              </div>
            </div>
            <div>
              <BaseShowEditInput
                :label="$t('attributes.email')"
                v-model="implantation.email"
                :errors="errors.email"
                :placeholder="$t('attributes.email')"
                :editionMode="editionMode"
                :required="true"
              />
            </div>
            <div>
              <BaseCountryShowEditSelectSimple
                v-model="implantation.country"
                :metadata="metadata"
                :errors="errors"
                :edition-mode="editionMode"
              />
            </div>
            <div>
              <BaseShowEditInput
                :label="$t('attributes.website')"
                v-model="implantation.website"
                :errors="errors.website"
                :placeholder="$t('attributes.website')"
                :editionMode="editionMode"
              />
            </div>
            <div>
              <BaseShowEditPhoneInput
                :label="$t('attributes.phone')"
                name="phone"
                :editionMode="editionMode"
                v-model:countryValue="implantation.phone_country"
                v-model:numberValue="implantation.phone_field"
                :errors="errors"
                :metadata="metadata"
              />
            </div>
            <div>
              <BaseLanguageShowEditSelectSimple
                v-model="implantation.language"
                :metadata="metadata"
                :errors="errors"
                :edition-mode="editionMode"
              />
            </div>
          </div>

          <!--              <div class='flex justify-end' v-if="$can('manage_content')">-->
          <!--                <BaseButton-->
          <!--                            v-if="editionMode"-->
          <!--                            :isElevated='true'-->
          <!--                            icon='paper-plane'-->
          <!--                            @click='submitForm'-->
          <!--                            :title="$t(buttonText, { var: $t('global.implantation')} ) " />-->
          <!--              </div>-->
        </PageSection>

        <ImplantationAssetIndexComponent
          :assets="implantation.assets"
          @addAsset="handleAddAsset(asset)"
          :implantationId="implantation.id"
          :editionMode="editionMode"
          v-if="
            this.$route.name === 'settings_edit_implantation_route' &&
            implantation.assets
          "
        />
      </div>
    </template>
  </SettingsPageFull>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'

import ImplantationAssetIndexComponent from '../../asset/index/ImplantationAssetIndexComponent'

export default {
  name: 'TheImplantationFormPage',
  components: {
    ImplantationAssetIndexComponent
  },
  data() {
    return {
      editionMode: false
    }
  },
  computed: {
    ...mapGetters({
      implantation: 'implantation/getSelectedImplantation',
      metadata: 'implantation/getImplantationMetadata',
      asset: 'getass',
      errors: 'auth/getErrors'
    }),
    buttonText() {
      return this.$route.name === 'settings_create_implantation_route'
        ? 'button.add_new_f'
        : 'button.edit_new_f'
    },
    pageTitle() {
      return this.implantation.name
    }
  },
  methods: {
    ...mapActions({
      fetchNewImplantation: 'implantation/fetchNewImplantation',
      fetchImplantationByID: 'implantation/fetchImplantationByID',
      fetchNewAsset: 'asset/fetchNewAsset',
      postNewImplantation: 'implantation/storeNewImplantation',
      updateImplantation: 'implantation/updateImplantation'
    }),
    getCompanyAndChangeEditionMode() {
      if (this.editionMode) {
        this.fetchImplantationByID({ id: this.$route.params.id })
      }
      this.editionMode = !this.editionMode
    },
    handleAddAsset(asset) {
      this.implantation.assets.push(asset)
    },
    getInputValue({ attribute, value }) {
      if (value !== undefined) {
        this.implantation[attribute] = value
      }
    },
    submitForm() {
      if (this.$route.name === 'settings_create_implantation_route') {
        this.postNewImplantation({
          implantation: this.implantation
        }).then(() => {
          this.$h.toastSuccess(
            this.$t('toasts.created_f', {
              var: this.$t('global.implantation')
            })
          )
          this.$router.push({ name: 'settings_list_implantation' })
        })
      } else {
        this.updateImplantation({
          id: this.$route.params.id,
          implantation: this.implantation
        }).then(() => {
          this.$h.toastSuccess(
            this.$t('toasts.updated_f', {
              var: this.$t('global.implantation')
            })
          )
          this.editionMode = false
        })
      }
    }
  },
  beforeMount() {
    if (this.$route.name === 'settings_edit_implantation_route') {
      this.fetchImplantationByID({ id: this.$route.params.id })
      this.fetchNewAsset()
    } else {
      this.fetchNewImplantation()
      this.fetchNewAsset()
      this.editionMode = true
    }
  }
}
</script>
